// Random interior header bg image
export default function randomImgInit() {
    document.addEventListener("DOMContentLoaded", () => {
        const classes = ["bg-header-1", "bg-header-2", "bg-header-3", "bg-header-4", "bg-header-5", "bg-header-7", "bg-header-8", "bg-header-9", "bg-header-10"];

        let randomNumber = Math.floor(Math.random() * classes.length);

        if (document.querySelector(".content-wrapper-photo")) {
            document.querySelector(".content-wrapper-photo").classList.add(classes[randomNumber]);
        }
    });
}
